import { render } from "./MainContacts.vue?vue&type=template&id=0db5cd9f"
import script from "./MainContacts.vue?vue&type=script&lang=js"
export * from "./MainContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__